import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncedPremiumState } from '@shared/models/state.model';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { PolicyDataService } from './policy-data.service';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PremiumSyncService {
  private readonly config = {
    apiUrl: `${environment.PROTOCOL}://${environment.API_URL}:${environment.API_PORT}/api/v1/c8`
  }
  private _syncedPremiumState: BehaviorSubject<SyncedPremiumState | null> = new BehaviorSubject(null);
  private syncPremiumEvents = new Subject<Object>();

  constructor(private http: HttpClient, private policyDataService: PolicyDataService) {
    this.initPremiumSync();
  }

  get isPremiumSyncEnabled() {
    const { premiumSyncEnabled } = this.policyDataService.getPolicyConfig() ?? {}
    return premiumSyncEnabled == true;
  }
  
  get syncedPremiumState() {
    if (!this.isPremiumSyncEnabled) return;
    return this._syncedPremiumState.asObservable()
  }
  
  get hasSyncedPremiumState() {
    const { premium, Error } = this._syncedPremiumState.getValue() ?? {}
    return Boolean(Error || Number.isInteger(premium))
  }

  syncPremium(coveragesPayload?: Object) {
    if (!this.isPremiumSyncEnabled) return;
    this.updateSyncedPremiumState({ premium: null })
    this.syncPremiumEvents.next(coveragesPayload)
  }
  
  updateSyncedPremiumState(premium: SyncedPremiumState) {
    this._syncedPremiumState.next(premium);
  }

  private initPremiumSync() {
    this.syncPremiumEvents.pipe(
      debounceTime(300),
      switchMap((coveragesPayload) =>
        this.http.post<SyncedPremiumState>(`${this.config.apiUrl}/quote-editor/premium`, coveragesPayload, { 
          params: { quoteId: this.policyDataService.getPolicyID() } 
        })
      )
    ).subscribe(val => this.updateSyncedPremiumState(val))
  }
}
